/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Divider from "@material-ui/core/Divider";
// import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Grid } from "@material-ui/core";
import { getRestrictiveValue } from "../../utils/utils";
import { RESTRICTIVE_VALIDATION_RULES } from "../../pages/IEPFReport/validationRules";
import { HINT_FORM_TEXT } from "../../constants";

// Icon for the document preview
// import FileCopyIcon from "@material-ui/icons/FileCopy";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "8px",
    boxShadow: theme.shadows[5],
    padding: 0,
    width: "800px",
    maxWidth: "90vw",
    outline: "none",
  },
  header: {
    padding: theme.spacing(3, 4),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
    fontSize: "2rem",
  },

  content: {
    padding: theme.spacing(3, 4),
  },
  formGroup: {
    marginBottom: theme.spacing(3),
  },
  formLabel: {
    fontWeight: "bold",
    color: "#054f96",
    marginBottom: theme.spacing(1),
    display: "block",
  },
  fileInput: {
    display: "none",
  },
  formInput: {
    width: "100%",
  },
  errorMessage: {
    fontSize:"16px",
    fontWeight: 600,
    color: "red",
  },
  actionButtons: {
    padding: theme.spacing(3, 4),
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
  },
  cancelButton: {
    backgroundColor: "#555",
    color: "white",
    padding: theme.spacing(1.5, 4),
    "&:hover": {
      backgroundColor: "#444",
    },
  },
  uploadButton: {
    backgroundColor: "#00205b",
    color: "white",
    padding: theme.spacing(1.5, 4),
    "&:hover": {
      backgroundColor: "#001845",
    },
  },
}));

function AddSrnModal({ open, onClose }) {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    folioId: "",
    SRN: "",
  });
  const [error,setError]=useState("")

  const handleChange = (e) => {
    const { name, value } = e.target;

    const fieldRules = RESTRICTIVE_VALIDATION_RULES[name];
    const restrictedValue = getRestrictiveValue(value, fieldRules);

    setFormData((prev) => ({
      ...prev,
      [name]: restrictedValue,
    }));
  };
  const handleSave = (e) => {
    // Handle upload logic here
    e.preventDefault()
    if(!formData.folioId){
      setError("Please enter folioId")
      return
    }
    if(!formData.SRN){
      setError("Please enter SRN")
      return
    }
    console.log("formData", formData);
    onClose();
    // history.push('/questionnaire');
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={onClose}
      aria-labelledby="upload-document-modal"
    >
      <div className={classes.paper}>
        <div className={classes.header}>
          <div>
            <Typography className={classes.title} variant="h2">
              Add SRN
            </Typography>
          </div>
          <IconButton onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </div>

        <Divider />

        <div className={classes.content}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <div className={classes.formGroup}>
                <Typography className={classes.formLabel}>
                  Folio/Dp ID
                </Typography>
                <TextField
                  // label="Please Enter"
                  placeholder={HINT_FORM_TEXT.folioId}
                  variant="outlined"
                  name="folioId"
                  value={formData.folioId}
                  onChange={handleChange}
                  className={classes.formInput}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.formGroup}>
                <Typography className={classes.formLabel}>SRN</Typography>
                <TextField
                  // label="Please Enter"
                  placeholder={HINT_FORM_TEXT.SRN}
                  variant="outlined"
                  name="SRN"
                  value={formData.SRN}
                  onChange={handleChange}
                  className={classes.formInput}
                />
              </div>
            </Grid>
          </Grid>
        {error && (
          <Typography className={classes.errorMessage}>{error}</Typography>
        )}
        </div>


        <div className={classes.actionButtons}>
          <Button
            className={classes.cancelButton}
            variant="contained"
            disableElevation
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className={classes.uploadButton}
            variant="contained"
            disableElevation
            disabled={formData.SRN === "" && formData.folioId===""}
            onClick={handleSave}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  );
}

AddSrnModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddSrnModal;
